import { ListBooking } from "~/components/admin/bookings";
import PageMeta from "~/components/common/meta";

export const ScreenAllBookings = () => {
  return (
    <>
      <PageMeta title="List Bookings | Art Handler" />
      <ListBooking />
    </>
  );
};
